"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["INVALID_BOT_CHECKSUM"] = "INVALID_BOT_CHECKSUM";
    ErrorCode["INVALID_LUIS_AUTHORING_KEY"] = "INVALID_LUIS_AUTHORING_KEY";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
//# sourceMappingURL=ErrorCodes.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@conversationlearner/models/dist/ErrorCodes.js
// module id = 734
// module chunks = 0